import throttle from 'lodash/throttle';
import { useEffect, useRef, useState } from 'react';

export function useFormScroll(useStepNavigation: boolean) {
  const [visibleStep, setVisibleStep] = useState(0);
  const ref = useRef<HTMLFormElement>(null);

  useEffect(() => {
    const element = ref.current;

    if (!useStepNavigation || !element) return;

    const handleScroll = throttle(() => {
      const { clientWidth, scrollLeft } = element;
      const newStep = Math.round(scrollLeft / clientWidth);
      setVisibleStep(newStep);
    }, 150);

    element.addEventListener('scroll', handleScroll);

    return () => element.removeEventListener('scroll', handleScroll);
  }, [useStepNavigation]);

  function jump(steps: number) {
    ref.current?.children.item(visibleStep + steps)?.scrollIntoView();
  }

  return {
    ref,
    jump,
    isLastStep: ref.current ? visibleStep === ref.current.children.length - 1 : false,
    isFirstStep: ref.current ? visibleStep === 0 : true,
  };
}
